export default "__VITE_ASSET__07e5520b__"